module.exports = __webpack_public_path__ + "img/thumb_20.d7decc2d.jpg";